// extracted by mini-css-extract-plugin
export default {"container":"ghEazGQvJXspdvUBnGqb","description":"z7yvbbAsr7lwE9gdqFil"};